import React from 'react'
import css from './Loader.module.css'

function Loader({ text = "Loading..." }) {
  return (
    <div className={css.loader}>
        <div className={css.loaderInner}></div>
        {text && <div className={css.loaderText}>{text}</div>}
    </div>
  )
}

export default Loader